import React from "react";
import { useNavigate } from "react-router-dom";
import { Menu, ShoppingCart } from "lucide-react";
import { useStore } from "@/context/StoreContext";

export default function TopBar() {
  const navigate = useNavigate();
  const { setNavOpen, setCartOpen, cartCount } = useStore();

  return (
    <header
      className="fixed top-0 inset-x-0 h-16 bg-black border-b border-[#E60000] z-40 flex items-center justify-between px-4"
      data-testid="top-bar"
    >
      <button data-testid="open-nav-btn" onClick={() => setNavOpen(true)} className="text-[#F0EDEA] p-2 -ml-2 active:scale-90 transition-transform" aria-label="Menu">
        <Menu size={28} />
      </button>

      <button onClick={() => navigate("/")} data-testid="logo-home-btn" className="absolute left-1/2 -translate-x-1/2">
        <img src="/logo_wide.webp" alt="RED EYE" className="h-10 w-auto" />
      </button>

      <button data-testid="open-cart-btn" onClick={() => setCartOpen(true)} className="relative text-[#F0EDEA] p-2 -mr-2 active:scale-90 transition-transform" aria-label="Cart">
        <ShoppingCart size={26} />
        {cartCount > 0 && (
          <span data-testid="cart-count-badge" className="absolute -top-0.5 -right-0.5 bg-[#E60000] text-white text-[11px] font-bold rounded-full min-w-[18px] h-[18px] px-1 flex items-center justify-center">
            {cartCount}
          </span>
        )}
      </button>
    </header>
  );
}
